
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "../CSS/ServiceFeeModal.css";

const ServiceFeeModal = ({ onClose }) => {
  const [mpesaNumber, setMpesaNumber] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("idle");
  const [isPolling, setIsPolling] = useState(false);
  const [start_CD, setSD] = useState(false);

  const handlePayment = async (e) => {
    e.preventDefault();

    if (!mpesaNumber.trim()) {
      return;
    }

    setPaymentStatus("pending");
    setIsPolling(false);

    try {
      const response = await fetch(
        "https://darajaapi-2.onrender.com/stkpush_acl",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            amount: 1,
            myID: `${Cookies.get("userID")}`,
            mpesa: `${"254" + mpesaNumber}`,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          `STK request failed with status ${response.status}`
        );
      }

      const data = await response.json();

      console.log("STK response:", data);

      if (data.status === "pending") {
        setPaymentStatus("pending");
        setIsPolling(true);
      } else {
        setPaymentStatus("pending");
        setIsPolling(true);
      }
    } catch (error) {
      console.error("STK Push error:", error);
     // setPaymentStatus("failed");
      //setIsPolling(false);
    } finally {
      setSD(true);
    }
  };

  useEffect(() => {
    if (!mpesaNumber || !isPolling) {
      return;
    }

    const checkPaymentStatus = async () => {
      try {
        const response = await fetch(
          `https://darajaapi-2.onrender.com/payment-status?number=254${mpesaNumber}`
        );

        if (!response.ok) {
          throw new Error(
            `Payment status request failed with status ${response.status}`
          );
        }

        const data = await response.json();

        console.log("Payment status from backend:", data);

        if (data.status === "pending") {
          setPaymentStatus("pending");
          return;
        }

        if (data.status === "success") {
          console.log("✅ PAYMENT SUCCESSFUL");
          setPaymentStatus("success");
          setIsPolling(false);
          return;
        }

        if (data.status === "cancelled") {
          console.log("❌ USER CANCELLED THE TRANSACTION");
          setPaymentStatus("cancelled");
          setIsPolling(false);
          return;
        }

        if (data.status === "failed") {
          console.log("⚠️ PAYMENT FAILED");
          setPaymentStatus("failed");
          setIsPolling(false);
          return;
        }
      } catch (error) {
        console.log("Error checking payment status:", error);
      }
    };

    // checkPaymentStatus();

    const interval = setInterval(() => {
     // checkPaymentStatus();
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [mpesaNumber, isPolling]);

  const getButtonText = () => {
    if (paymentStatus === "pending") {
      return "Incoming M-Pesa prompt";
    }

    if (paymentStatus === "cancelled") {
      return "Transaction cancelled";
    }

    if (paymentStatus === "success") {
      return "Payment successful";
    }

    if (paymentStatus === "failed") {
      return "Payment failed";
    }

    return "Send";
  };

  const isButtonDisabled =
    !mpesaNumber.trim() ||
    paymentStatus === "pending" ||
    paymentStatus === "success";

  const handleNewPayment = () => {
    setPaymentStatus("idle");
    setIsPolling(false);
  };

  return (
    <div
      className="service-fee-overlay"
      onClick={onClose}
    >
      <div
        className="service-fee-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="service-fee-close"
          onClick={onClose}
          type="button"
        >
          ×
        </button>

        <div className="service-fee-icon">
          KSh
        </div>

        <span className="service-fee-label">
          SERVICE FEE
        </span>

        <h2>
          Complete your payment
        </h2>

        <p className="service-fee-description">
          A service fee of{" "}
          <strong>KSh 1,500</strong>{" "}
          is required to continue with your
          Advenware Careere Link service.
        </p>

        <div className="service-fee-amount">
          <span>
            AMOUNT TO PAY
          </span>
          <strong>
            KSh 1,500
          </strong>
        </div>

        <form onSubmit={handlePayment}>
          <div className="service-fee-field">
            <label>
              M-Pesa number
            </label>

            <div className="service-fee-input-wrapper">
              <span className="mpesa-prefix">
                +254
              </span>

              <input
                type="tel"
                value={mpesaNumber}
                onChange={(e) => {
                  setMpesaNumber(e.target.value);
                  setPaymentStatus("idle");
                  setIsPolling(false);
                }}
                placeholder="712 345 678"
                maxLength="9"
                disabled={paymentStatus === "pending"}
                autoFocus
              />
            </div>

            <small>
              Enter the phone number registered with M-Pesa.
            </small>
          </div>

          {paymentStatus === "pending" && (
            <div className="service-fee-prompt">
              <div className="service-fee-spinner"></div>

              <div>
                <strong>
                  Incoming M-Pesa prompt
                </strong>
                <span>
                  Check your phone and enter your
                  M-Pesa PIN to complete the payment.
                </span>
              </div>
            </div>
          )}

          {paymentStatus === "cancelled" && (
            <div className="service-fee-prompt">
              <div>
                <strong>
                  Transaction cancelled
                </strong>
                <span>
                  You cancelled the M-Pesa request.
                  You can try again.
                </span>
              </div>
            </div>
          )}

          {paymentStatus === "success" && (
            <div className="service-fee-prompt">
              <div>
                <strong>
                  Payment successful
                </strong>
                <span>
                  Your payment has been received successfully.
                </span>
              </div>
            </div>
          )}

          {paymentStatus === "failed" && (
            <div className="service-fee-prompt">
              <div>
                <strong>
                  Payment failed
                </strong>
                <span>
                  The M-Pesa transaction could not be completed.
                </span>
              </div>
            </div>
          )}

          <div className="service-fee-actions">
            <button
              type="button"
              className="service-fee-cancel"
              onClick={onClose}
              disabled={paymentStatus === "pending"}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="service-fee-send"
              disabled={isButtonDisabled}
            >
              {getButtonText()}

              {paymentStatus === "idle" && (
                <span>
                  →
                </span>
              )}
            </button>
          </div>

          {(paymentStatus === "cancelled" ||
            paymentStatus === "failed") && (
            <button
              type="button"
              onClick={handleNewPayment}
              style={{
                marginTop: "10px",
                width: "100%",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              Try again
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default ServiceFeeModal;

